import { definePreset, palette } from '@primeng/themes';
import Lara from '@primeng/themes/lara';

// const values1 = palette('#2C93AE');

/** option 1 **/
/*
sana: {
  '50': '#f4fafb',
    '100': '#cce5ec',
    '200': '#a4d1dc',
    '300': '#7cbccd',
    '400': '#54a8bd',
    '500': '#2c93ae',
    '600': '#257d94',
    '700': '#1f677a',
    '800': '#185160',
    '900': '#123b46',
    '950': '#0b252c'
},
    primary: {
      '50': '#f4fafb',
      '100': '#cce5ec',
      '200': '#a4d1dc',
      '300': '#7cbccd',
      '400': '#54a8bd',
      '500': '#2c93ae',
      '600': '#257d94',
      '700': '#1f677a',
      '800': '#185160',
      '900': '#123b46',
      '950': '#0b252c'
    },
*/

/** option 2 */
/*   primitive: {
     sana: {
       '50': '{cyan.50}',
       '100': '{cyan.100}',
       '200': '{cyan.200}',
       '300': '{cyan.300}',
       '400': '{cyan.400}',
       '500': '{cyan.500}',
       '600': '{cyan.600}',
       '700': '{cyan.700}',
       '800': '{cyan.800}',
       '900': '{cyan.900}',
       '950': '{cyan.950}'
     },
     primary: {
       '50': '{cyan.50}',
       '100': '{cyan.100}',
       '200': '{cyan.200}',
       '300': '{cyan.300}',
       '400': '{cyan.400}',
       '500': '{cyan.500}',
       '600': '{cyan.600}',
       '700': '{cyan.700}',
       '800': '{cyan.800}',
       '900': '{cyan.900}',
       '950': '{cyan.950}'
     },
     green: palette('#15803d'),
     red: palette('#b91c1c'),
     sky: palette('#0e7490'),
   },
*/

export const SanactivoPrimengPreset = definePreset(Lara, {
  primitive: {
    sana: {
      '50': '#f4fafb',
      '100': '#cce5ec',
      '200': '#a4d1dc',
      '300': '#7cbccd',
      '400': '#54a8bd',
      '500': '#2c93ae',
      '600': '#257d94',
      '700': '#1f677a',
      '800': '#185160',
      '900': '#123b46',
      '950': '#0b252c'
    },
    primary: {
      '50': '#f4fafb',
      '100': '#cce5ec',
      '200': '#a4d1dc',
      '300': '#7cbccd',
      '400': '#54a8bd',
      '500': '#2c93ae',
      '600': '#257d94',
      '700': '#1f677a',
      '800': '#185160',
      '900': '#123b46',
      '950': '#0b252c'
    },
    green: palette('#15803d'),
    red: palette('#b91c1c'),
    sky: palette('#0e7490')
  },
  semantic: {
    primary: {
      50: '{sana.50}',
      100: '{sana.100}',
      200: '{sana.200}',
      300: '{sana.300}',
      400: '{sana.400}',
      500: '{sana.500}',
      600: '{sana.600}',
      700: '{sana.700}',
      800: '{sana.800}',
      900: '{sana.900}',
      950: '{sana.950}'
    }
  }
});
